// extracted by mini-css-extract-plugin
module.exports = {"table":"wizard-validity_table__uvqiI"};